import { createSlice } from '@reduxjs/toolkit';
import FavoriteLoanOfficersRepository from 'repositories/realEstateAgent/FavoriteLoanOfficersRepository';
import { createRestSlice } from 'utils/RestSlice';

const restSlice = createRestSlice({
  resource: 'favoriteLoanOfficer',
  pluralResource: 'favoriteLoanOfficers',
  repository: FavoriteLoanOfficersRepository,
  slices: [
    'loadFavoriteLoanOfficers',
    'createFavoriteLoanOfficer',
    'deleteFavoriteLoanOfficer',
    'updateFavoriteLoanOfficer',
  ],
});

const initialState = {
  ...restSlice.initialState,
};

const realEstateAgentFavoriteLoanOfficersSlice = createSlice({
  name: 'realEstateAgentFavoriteLoanOfficersSlice',
  initialState,
  reducers: {
    ...restSlice.reducers,
  },
});

export default realEstateAgentFavoriteLoanOfficersSlice;
export const realEstateAgentFavoriteLoanOfficersReducer = realEstateAgentFavoriteLoanOfficersSlice.reducer;
export const realEstateAgentFavoriteLoanOfficersHooks = restSlice.hooks(
  realEstateAgentFavoriteLoanOfficersSlice,
  'realEstateAgentFavoriteLoanOfficersReducer',
);



// WEBPACK FOOTER //
// ./src/reducers/slices/realEstateAgent/favoriteLoanOfficersSlice.js